import React from 'react';
import { HiMail, HiLocationMarker } from 'react-icons/hi';
import { useLanguage } from '../../i18n/LanguageContext';
import './Footer.css';

const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__grid">
          {/* Brand */}
          <div className="footer__brand">
            <div className="footer__logo">
              <img
                src="/Logo.png"
                alt={t('brand.logoAlt')}
                className="footer__logo-img"
              />
              <div>
                <span className="footer__logo-title">MAI</span>
                <span className="footer__logo-sub">{t('brand.subtitle')}</span>
              </div>
            </div>
            <p className="footer__brand-desc">
              {t('footer.brandDesc')}
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer__section">
            <h4>{t('footer.quickLinksTitle')}</h4>
            <ul>
              <li><a href="#home">{t('footer.quickLinks.home')}</a></li>
              <li><a href="#why">{t('footer.quickLinks.why')}</a></li>
              <li><a href="#solutions">{t('footer.quickLinks.solutions')}</a></li>
              <li><a href="#demo">{t('footer.quickLinks.platform')}</a></li>
              <li><a href="#team">{t('footer.quickLinks.team')}</a></li>
              <li><a href="#contact">{t('footer.quickLinks.contact')}</a></li>
            </ul>
          </div>

          {/* Solutions */}
          <div className="footer__section">
            <h4>{t('footer.solutionsTitle')}</h4>
            <ul>
              <li><a href="#solutions">{t('footer.solutionsLinks.platform')}</a></li>
              <li><a href="#solutions">{t('footer.solutionsLinks.language')}</a></li>
              <li><a href="#solutions">{t('footer.solutionsLinks.vision')}</a></li>
              <li><a href="#solutions">{t('footer.solutionsLinks.automation')}</a></li>
              <li><a href="#solutions">{t('footer.solutionsLinks.responsible')}</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer__section">
            <h4>{t('footer.contactTitle')}</h4>
            <div className="footer__contact-list">
              <div className="footer__contact-item">
                <HiLocationMarker />
                <span>{t('footer.contactLocation')}</span>
              </div>
              <div className="footer__contact-item">
                <HiMail />
                <span>{t('footer.contactEmail')}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <span>{t('footer.copyright').replace('{year}', year)}</span>
          <span className="footer__bottom-note">{t('footer.bottomNote')}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
